import {useState } from "react";
import UIServicesOutCard from "../molecules/UIServicesOutCard";
import UIServicesOutControls from "../molecules/UIServicesOutControls";
import UITitle from "../atoms/UITitle";
import { useCarrouselSlide } from "../../hooks/useCarrouselSlide";
const data = [
  {
    icon: "/assets/icon/icon_folder.svg",
    title: "Seguro de desempleo",
    description: "Desarrolla y potencializa nuevas habilidades para fortalecer tu perfil profesional.",
  },
  {
    icon: "/assets/icon/icon_seguro_independientes.svg",
    title: "Seguro independientes",
    description: "Fortalece las herramientas necesarias para hacer crecer tu idea de negocio.",
  },
  {
    icon: "/assets/icon/icon_orientacion.svg",
    title: "Seguro fraude",
    description: "Conoce y aprovecha los diferentes servicios para cuidar tus finanzas personales.",
  },
  {
    icon: "/assets/icon/icon_seguro_bienestar.svg",
    title: "Seguro bienestar",
    description: "Descubre los servicios digitales que te ayudarán a encontrar un equilibrio en tu vida.",
  },
  {
    icon: "/assets/icon/icon_seguro_vida.svg",
    title: "Seguro vida",
    description: "Conoce los servicios digitales que te ayudarán a encontrar un equilibrio en tu vida.",
  },
];
export default function UIServicesOut() {
  const [activeIndex, setActiveIndex] = useState(0);
  const {generatePadingX,handleClick,handleScroll,scrollRef} = useCarrouselSlide({activeIndex,setActiveIndex,dataLength:data.length,scrollLeft:286 + 30,scrollPositionDiff:400})

  // Function to handle moving to the previous card
  function handlePrev() {
    setActiveIndex((prevIndex) => {
      const newIndex = prevIndex - 1;
      return newIndex < 0 ? data.length - 1 : newIndex;
    });
  }

  // Function to handle moving to the next card
  function handleNext() {
    setActiveIndex((prevIndex) => {
      const newIndex = prevIndex + 1;
      return newIndex >= data.length ? 0 : newIndex;
    });
  }



  return (
    <section className="relative animate-appear  flex flex-col md:flex-row gap-[24px] flex-start md:gap-[40px] md:pl-[10%] py-[50px] md:py-[95px] bg-gradient-to-r from-[rgb(0,188,140)] to-[rgb(20,124,88)]">
      <div className="flex md:gap-[50px] gap-[24px] flex-col justify-start  items-start md:w-4/12 px-[10%] md:px-0">
        <UITitle h3 className="text-[26px] md:text-[38px] mb-4 font-BNPPSquareBold text-white tracking-tight leading-tight ">
          Servicios diseñados <br className="hidden md:flex" />
          exclusivamente para ti
        </UITitle>
        <p className="text-[16px] text-white md:text-[18px]  font-OpenSans">
          Conoce y disfruta el Ecosistema digital de tu seguro. Servicios
          personalizados que se habilitan de acuerdo con las coberturas de tu
          producto.
        </p>
        <UIServicesOutControls
          className="hidden md:flex"
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </div>
      <div className="relative right-0 flex justify-start w-full md:w-6/12 lg:w-7/12 md:absolute">
        <div className="absolute hidden md:flex w-[40px] bottom-4 z-10 top-0 left-0 "></div>
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          style={{paddingLeft:generatePadingX(scrollRef.current?.offsetWidth,284),paddingRight:generatePadingX(scrollRef.current?.offsetWidth,284)}}
          className="flex  md:pl-[40px] px-[10%] overflow-x-auto scroll-hidden md:custom-scroll pb-[20px] gap-[30px] w-full flex-nowrap "
        >
          {data.map((tab) => {
            return (
              <UIServicesOutCard key={tab.title} title={tab.title} icon={tab.icon} description={tab.description} />
            );
          })}
        </div>
      </div>
      <div className="flex justify-center gap-2 md:hidden">
        {data.map((tab, index) => {
          return (
            <div key={tab.title} onClick={() => handleClick(index) } className={`block  duration-500 h-[6px]  rounded-full ${activeIndex === index ? "w-[17px] bg-secondary-green" : "w-[6px] bg-[rgba(255,255,255,0.8)]"}`} />
          );
        })}
      </div>
    </section>
  );
}

